module.exports = __webpack_public_path__ + "img/shirt_d.284b3bd5.gif";